let _authorize = null;
//keys
const CURRENT_ENTITY_ID = "CURRENT_ENTITY_ID";
const CURRENT_ENTITY_DATA = "CURRENT_ENTITY_DATA";
const ENTITIES_LIST = "ENTITIES_LIST";

const keys = {
  //Keys
  CURRENT_ENTITY_ID,
  CURRENT_ENTITY_DATA,
  ENTITIES_LIST,
};

const consts = {
  //const values
};

const init = ({ authorize }) => {
  !_authorize && (_authorize = authorize);
};

const STATE = {
  [CURRENT_ENTITY_ID]: null,
  [CURRENT_ENTITY_DATA]: null,
  [ENTITIES_LIST]: [],
};

const reloadState = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 704801,
    };
  }
  return STATE;
};

const setValue = (authorize, keyName, value) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 824896,
    };
  }
  STATE[keyName] = value;
};

const reset = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 847544,
    };
  }
  STATE[CURRENT_ENTITY_ID] = null;
  STATE[CURRENT_ENTITY_DATA] = null;
  STATE[ENTITIES_LIST] = [];
};

const CurrentEntityState = {
  //Keys
  KEYS: { ...keys },
  ...keys,

  //Values
  CONSTS: { ...consts },
  ...consts,
  reloadState,
  init,
  setValue,
  reset,
};

export default CurrentEntityState;

export {
  keys as KEYS,
  consts as CONSTS,
  CURRENT_ENTITY_ID,
  CURRENT_ENTITY_DATA,
  ENTITIES_LIST,
};
